/**
 * Determine if the supplied error is a ClientSDK business-related error.
 *
 * All 4XX `error.status` values from the SDK are considered business errors,
 * except for 429 (throttling) and 408 (timeout), which are excluded.
 * This logic may need refinement as new edge cases are discovered.
 *
 * @param error
 */
export function isClientSdkBusinessError(error: { status?: number }): boolean {
    if (!error.status) return false;

    return (
        error.status >= 400 &&
        error.status < 500 &&
        error.status !== 429 &&
        error.status !== 408
    );
}
